import React, { useState, useRef } from "react";
import {
  VideoWrapper,
  VideoContainer,
  Video,
  ControlsContainer,
  VolumeButton,
} from "../styles/components/Global/Video";

const LotusVideo = ({ scale, margin, autoplay, loop }) => {
  const videoRef = useRef(null);

  const enableAutoPlay = !!autoplay;
  const enableLoop = !!loop;

  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const toggleMute = () => {
    const video = videoRef.current;
    video.muted = !video.muted;
  };

  return (
    <VideoWrapper
      className={scale && "scale-video"}
      $scale={scale}
      $margin={margin}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <VideoContainer>
        <Video>
          <video
            ref={videoRef}
            className="video"
            playsInline
            autoPlay={enableAutoPlay}
            loop={enableLoop}
            muted
            controls={false}
          >
            <source
              src="https://www.datocms-assets.com/40484/1695288124-lotus-for-the-drivers.mp4"
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
          <ControlsContainer className={isHovered ? "show-controls" : ""}>
            <VolumeButton onClick={toggleMute}>
              {videoRef.current?.muted ? (
                <img
                  src="https://www.datocms-assets.com/40484/1695649921-with-volume.png"
                  alt="Muted"
                />
              ) : (
                <img
                  src="https://www.datocms-assets.com/40484/1695649917-no-volume.png"
                  alt="Not muted"
                />
              )}
            </VolumeButton>
          </ControlsContainer>
        </Video>
      </VideoContainer>
    </VideoWrapper>
  );
};

export default LotusVideo;
